module.exports = "/static/assets/1dfe5425b42628b6f1df1f39e97a319f.svg";